import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const countryData = {
  DE: { name: 'Germany', flag: '🇩🇪', color: 'from-yellow-400 to-red-500' },
  NL: { name: 'Netherlands', flag: '🇳🇱', color: 'from-orange-500 to-blue-600' },
  IT: { name: 'Italy', flag: '🇮🇹', color: 'from-green-500 to-red-500' },
  FR: { name: 'France', flag: '🇫🇷', color: 'from-blue-500 to-red-500' },
  PL: { name: 'Poland', flag: '🇵🇱', color: 'from-white to-red-500' },
  ES: { name: 'Spain', flag: '🇪🇸', color: 'from-red-500 to-yellow-400' },
  PT: { name: 'Portugal', flag: '🇵🇹', color: 'from-green-600 to-red-600' },
  BE: { name: 'Belgium', flag: '🇧🇪', color: 'from-black to-yellow-400' },
  SE: { name: 'Sweden', flag: '🇸🇪', color: 'from-blue-600 to-yellow-400' },
  FI: { name: 'Finland', flag: '🇫🇮', color: 'from-white to-blue-600' },
};

export const CountryCard = ({ country, isLarge = false }) => {
  const data = countryData[country.code] || { name: country.name, flag: '🏳️', color: 'from-gray-400 to-gray-600' };
  
  return (
    <Link
      to={`/country/${country.code}`}
      data-testid={`country-card-${country.code.toLowerCase()}`}
      className={`group relative bg-white rounded-2xl overflow-hidden border border-gray-100 card-hover cursor-pointer ${
        isLarge ? 'p-8' : 'p-6'
      }`}
    >
      {/* Gradient accent on hover */}
      <div className={`absolute inset-0 bg-gradient-to-br ${data.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />
      
      <div className="relative">
        {/* Flag */}
        <div className={`flag-emoji mb-4 ${isLarge ? 'text-5xl' : 'text-4xl'}`}>
          {data.flag}
        </div>
        
        {/* Country Name */}
        <h3 className={`font-bold text-[#002A76] mb-2 ${isLarge ? 'text-2xl' : 'text-lg'}`}>
          {country.name}
        </h3>
        
        {/* Description */}
        <p className={`text-gray-600 mb-4 ${isLarge ? 'text-base' : 'text-sm'} line-clamp-2`}>
          {country.description}
        </p>
        
        {/* CTA */}
        <div className="flex items-center text-[#0AA06A] font-medium text-sm group-hover:translate-x-1 transition-transform">
          Explore opportunities
          <ArrowRight size={16} className="ml-1" />
        </div>
      </div>
    </Link>
  );
};

export default CountryCard;
